import Swiper from 'swiper';

export default function() {

    let itemsSliders = document.getElementsByClassName('js-items-slider');

    Array.from(itemsSliders).forEach(function (slider) {

        let itemsSwiper = new Swiper(slider, {
            loop: false,
            speed: 600,
            spaceBetween: 20,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 'auto',
            navigation: {
                nextEl: slider.parentElement.getElementsByClassName('items-slider__arrow-next')[0],
                prevEl: slider.parentElement.getElementsByClassName('items-slider__arrow-prev')[0]
            },
            breakpoints: {
                765: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
                980: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                1170: {
                    spaceBetween: 30,
                    slidesPerView: 4,
                }
            }
        });
    });

}

